import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import DashboardProfile from '../../../shared/components/profile/DashboardProfile';
import { adminSideLinks } from '../adminRoutes';

function AdminProfilePage() {
  return (
    <DashboardShell role="ADMIN" sideLinks={adminSideLinks}>
      <DashboardProfile role="ADMIN" />
    </DashboardShell>
  );
}

export default AdminProfilePage;
